module.exports = __webpack_public_path__ + "static/media/job-security.4834182c.jpg";